import React from "react";
import { Link } from "wouter";

interface Testimonial {
  id: number;
  name: string;
  service: string;
  rating: number;
  content: string;
  initials: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Sarah Johnson",
    service: "iPhone Screen Repair",
    rating: 5,
    content: "I dropped my iPhone and cracked the screen. ZiwaTech fixed it perfectly! They were professional, quick, and the price was reasonable. Highly recommend!",
    initials: "SJ"
  },
  {
    id: 2,
    name: "Michael Chen",
    service: "Laptop Battery Replacement",
    rating: 4.5,
    content: "My laptop battery was dying fast and I needed it fixed quickly. ZiwaTech did a great job and even gave me some tips on battery care. Very satisfied!",
    initials: "MC"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    service: "Tablet Data Recovery",
    rating: 5,
    content: "I accidentally deleted important files from my tablet. ZiwaTech managed to recover everything! Their technicians are skilled and the service was excellent.",
    initials: "ER"
  }
];

const TestimonialCard = ({ testimonial }: { testimonial: Testimonial }) => {
  const stars = [];
  
  // Generate full stars
  for (let i = 0; i < Math.floor(testimonial.rating); i++) {
    stars.push(<i key={`star-${i}`} className="fas fa-star"></i>);
  }
  
  // Add half star if needed
  if (testimonial.rating % 1 !== 0) {
    stars.push(<i key="half-star" className="fas fa-star-half-alt"></i>);
  }
  
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <div className="flex items-center mb-4">
        <div className="text-yellow-400 flex">
          {stars}
        </div>
        <span className="ml-2 text-gray-600">{testimonial.rating.toFixed(1)}</span>
      </div>
      <p className="text-gray-600 mb-4">{testimonial.content}</p>
      <div className="flex items-center">
        <div className="w-12 h-12 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-bold text-xl">
          {testimonial.initials}
        </div>
        <div className="ml-4">
          <h4 className="font-semibold">{testimonial.name}</h4>
          <p className="text-sm text-gray-500">{testimonial.service}</p>
        </div>
      </div>
    </div>
  );
};

const Testimonials = () => {
  return (
    <section className="py-16 bg-neutral">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">What Our Customers Say</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our satisfied customers have to say about our repair services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <TestimonialCard key={testimonial.id} testimonial={testimonial} />
          ))}
        </div>

        <div className="text-center mt-12">
          <Link 
            href="/reviews" 
            className="text-primary font-medium hover:text-[#FF6633] transition-colors flex items-center justify-center"
          >
            Read More Reviews
            <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
